// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"602275e6","399":"8d0f854c","1506":"602275e6","2145":"652c9bc3","2909":"481e8378","4472":"0b52de04"}[chunkId] + ".chunk.css";
};